module.exports = __webpack_public_path__ + "ec3f3704f9f5b40c516f8bdebd835836.pdf";